module.exports = __webpack_public_path__ + "static/media/exploreMenu.d77aabca.svg";